import {trigger, filter} from './lang.js';
// only pass thru certain ones

// if resolution = 32 then we let anything go
// if resolution 16 then we only let [0, 2, 4, 6]
// if resolution 8 then we only let [0, 4, 8,]
export const resolution = (resolution) => {
    return (stepData, stepNumber, time, effect) => {
        if ( stepNumber % (32 / resolution) === 0) {
            return  filter(true);
        }else {
            return  filter(false);
        }
    };
};
